import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Add "is-sticky" class on scroll
    // @see: https://ryanmulligan.dev/blog/sticky-header-scroll-shadow/
    const header = document.getElementById("main-header")
    const intercept = document.createElement("div")

    intercept.setAttribute("data-header-observer", "")
    header.before(intercept)

    const observer = new IntersectionObserver(([entry]) => {
      header.classList.toggle("is-sticky", !entry.isIntersecting)
    })

    observer.observe(intercept)
  }
}
